<template>
  <div class="pc-note__preview" v-show="visible">
    <!-- <note-name/> -->
    <!-- <note-tags/> -->
    <note-content/>
  </div>
</template>

<script>
import NoteContent from '@/components/note/preview/ContentUseMarkdownIt.vue'
// import NoteName from '@/components/note/preview/Name.vue'
// import NoteTags from '@/components/note/preview/Tags.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    NoteContent
    // NoteName
    // NoteTags
  },
  computed: {
    ...mapGetters({
      preview: 'workbench/current/preview'
    }),
    visible () {
      return this.preview
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
.pc-note__preview {

}
</style>
